import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0,0,256,256",
  width: "25px",
  height: "25px",
  "fill-rule": "nonzero"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#ffffff",
      "fill-rule": "nonzero",
      stroke: "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "",
      "stroke-dashoffset": "0",
      "font-family": "none",
      "font-weight": "none",
      "font-size": "none",
      "text-anchor": "none",
      style: {"mix-blend-mode":"normal"}
    }, [
      _createElementVNode("g", { transform: "translate(256,0) rotate(90) scale(5.12,5.12)" }, [
        _createElementVNode("path", { d: "M25,2c-12.683,0 -23,10.318 -23,23c0,12.682 10.317,23 23,23c12.683,0 23,-10.318 23,-23c0,-12.682 -10.317,-23 -23,-23zM7,25c0,-4.062 1.371,-7.8 3.65,-10.815l25.165,25.165c-3.015,2.279 -6.753,3.65 -10.815,3.65c-9.925,0 -18,-8.075 -18,-18zM39.35,35.815l-25.165,-25.165c3.015,-2.279 6.753,-3.65 10.815,-3.65c9.925,0 18,8.075 18,18c0,4.062 -1.371,7.8 -3.65,10.815z" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }